var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-2.5-1.5A.5.5,0,0,1-3-1a.5.5,0,0,1-.5-.5v-7A.5.5,0,0,1-3-9a.5.5,0,0,1,.5.5Zm3,0A.5.5,0,0,1,0-1a.5.5,0,0,1-.5-.5v-7A.5.5,0,0,1,0-9a.5.5,0,0,1,.5.5Zm3,0A.5.5,0,0,1,3-1a.5.5,0,0,1-.5-.5v-7A.5.5,0,0,1,3-9a.5.5,0,0,1,.5.5ZM2.691-13.3,3.528-12H6.5a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H6V-.5A2.5,2.5,0,0,1,3.5,2h-7A2.5,2.5,0,0,1-6-.5V-11h-.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.972l.809-1.3A1.5,1.5,0,0,1-1.447-14H1.447A1.422,1.422,0,0,1,2.691-13.3ZM-2.347-12H2.347l-.478-.765A.5.5,0,0,0,1.447-13H-1.447a.5.5,0,0,0-.422.235ZM-5-.5A1.5,1.5,0,0,0-3.5,1h7A1.5,1.5,0,0,0,5-.5V-11H-5V-.5Z",
    transform: "translate(7 14)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.4bf5658166187074e7b3cf463326126a.svg";
export { ForwardRef as ReactComponent };